import { Outlet, useLocation } from '@tanstack/react-router'
import { Atalhos } from './Atalhos'
import { TabBar } from './TabBar'
import { Trilho } from './Trilho'
import { DESKTOP, useMidia } from './use-midia'
import './casca.css'
import { AvisoDeNovaVersao } from './AvisoDeNovaVersao'
import { AvisoDeSync } from './AvisoDeSync'
import { isLeituraDeAgente } from './agent-view'

/**
 * A casca do app **autenticado**: as quatro abas de Navegação.md e o conteúdo
 * da rota. Montada só pelo `RequireAuth`, e só no estado `ready` — o fundo e as
 * defs de lente subiram para o `RootLayout`, que vale também para o login.
 *
 * ## A única rota que dispensa a casca
 *
 * `#agentInstructions` pede a página em modo leitura de agente: só o texto.
 * A barra de abas ali seria ruído no meio do que o modelo lê — quatro palavras
 * de navegação coladas no fim do contexto —, e a largura de celular quebraria
 * as linhas do markdown.
 *
 * A decisão mora **aqui**, e não na rota, porque é a casca que desenha a barra:
 * uma rota não tem como não-renderizar o que está acima dela.
 *
 * ## No desktop, a barra vira trilho
 *
 * A partir de 1024px a barra do rodapé dá lugar a um trilho lateral com tudo
 * rotulado, e o conteúdo recua para o lado dele (`casca.css`). O celular não
 * muda em nada. A troca é escolhida em JavaScript, e não escondida por CSS,
 * para nunca haver duas navegações na árvore — ver `useMidia`.
 */
export function AppShell() {
  const leitura = isLeituraDeAgente(useLocation().hash)
  const desktop = useMidia(DESKTOP)

  if (leitura) {
    return (
      <main className="mx-auto w-full max-w-3xl p-4">
        <Outlet />
      </main>
    )
  }

  return (
    <>
      <main
        className="casca mx-auto min-h-dvh w-full max-w-md px-4 pb-28"
        style={{ paddingTop: 'max(16px, env(safe-area-inset-top))' }}
      >
        {/* Antes da rota, em toda tela: os dados parados afetam todo número. */}
        <AvisoDeSync />
        <Outlet />
      </main>
      <AvisoDeNovaVersao />
      {desktop ? <Trilho /> : <TabBar />}
      <Atalhos />
    </>
  )
}
